import { SkillForm } from "@/core/skillForms/types";
import { createLaborInitialPetitionSkillStep2 } from "./step2";

export const createLaborInitialPetitionSkillForm: SkillForm = {
  skillId: "create_labor_initial_petition",
  title: "Petição Inicial Trabalhista",
  steps: [createLaborInitialPetitionSkillStep2],
};
